/**
 * @generated SignedSource<<038e2c8139549edfcb66bedbdedfb526>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedPurchaseButton_viewer$data = {
  readonly buyNowAddToCheckout: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"useShowPdpSharedShoppingButtons_viewer">;
  readonly " $fragmentType": "PdpSharedPurchaseButton_viewer";
};
export type PdpSharedPurchaseButton_viewer$key = {
  readonly " $data"?: PdpSharedPurchaseButton_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedPurchaseButton_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedPurchaseButton_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useShowPdpSharedShoppingButtons_viewer"
    },
    {
      "alias": "buyNowAddToCheckout",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "buyNowAddToCheckout"
        }
      ],
      "kind": "ScalarField",
      "name": "featureFlag",
      "storageKey": "featureFlag(feature:\"buyNowAddToCheckout\")"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "9ae6d04b8f82e8196764209e00467f7e";

export default node;
